export default [
  {
    path: "traffic",
    name: "traffic",
    component: (): Promise<any> =>
      import(/* webpackChunkName: "traffic" */ "@/components/Admin/Traffic/TrafficRequest.vue")
  }
];